import React from 'react';
import { AlertOutlined } from '@ant-design/icons';
import { Button, Tooltip } from 'antd';
import type { TooltipPlacement } from 'antd/es/tooltip';
import { useTranslation } from 'react-i18next';

interface CreateAlarmButtonProps {
  style?: React.CSSProperties;
  tooltipPosition: TooltipPlacement;
  openCreateAlarmModal: () => void;
}

export function CreateAlarmButton({
  style,
  tooltipPosition,
  openCreateAlarmModal,
}: CreateAlarmButtonProps) {
  const { t } = useTranslation('create-alarm-step');

  return (
    <Tooltip
      placement={tooltipPosition}
      title={t('create-alarm-step:createAlarmButtonTitle')}
      trigger="hover"
    >
      <Button
        icon={<AlertOutlined />}
        style={style}
        onClick={openCreateAlarmModal}
      />
    </Tooltip>
  );
}
